import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { FlightHeader } from "components/PurpleHeader/FlightHeader";
import React from "react";
import { useFlightDetail } from "./useFlightDetail";
import { flightSections } from "./flightSections";
import { getFlightFieldMetaData } from "shared/utils/fieldsHelper/flightFields";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import { Passengers } from "./passenger/Passengers";
import { LinkedShowSimplePanel } from "document/linkshow/LinkedShowSimplePanel";
import { ButtonSecondary } from "components/Atoms/Button";
import { type LinkShowToTravelConfig } from "components/LinkShowToTravelButton";

interface Props {
  flight: server.dto.Flight
  linkedShows: server.dto.LinkedShow[]
  passengers: server.dto.FlightPassenger[]
  linkShowToTravel: LinkShowToTravelConfig
  onUpdated: () => Promise<void>
}

export const FlightDetailSection = (props: Props) => {
  const {
    state,
    onValueChanged,
    getUpdateFlightInstruction,
    isCreatingPassenger,
    setIsCreatingPassenger,
  } = useFlightDetail(
    props.flight,
    props.passengers,
  );

  const fieldMetaData = getFlightFieldMetaData(site.currentEnvironment, state, props.flight.permissions);

  return <DetailSectionTemplate
    header={<FlightHeader flight={props.flight} passengers={props.passengers} />}
    isInPageEditable={props.flight.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={props.onUpdated}
    sections={[
      ...flightSections(state, fieldMetaData, getUpdateFlightInstruction),
      {
        type: "custom",
        key: "passengers",
        render: () => <SectionPanel.Panel
          key="passengers"
          id="passengers"
          button={props.flight.permissions.canModify ? <ButtonSecondary
            label={RESX.Buttons.btnNew}
            onClick={() => setIsCreatingPassenger(true)}
          /> : undefined}
          header={<SectionTemplateHeader>{RESX.Flight.Passengers}</SectionTemplateHeader>}
        >
          <Passengers
            isInPageEditable={props.flight.permissions.canModify}
            isCreating={isCreatingPassenger}
            setIsCreating={setIsCreatingPassenger}
            isInSidePanel={false}
            isPrivateJet={props.flight.flightType === "private"}
            flightId={props.flight.flightId}
            passengers={state.passengers}
            refetchPassengers={props.onUpdated}
          />
        </SectionPanel.Panel>
      }, {
        key: "linkedShows",
        type: "custom",
        render: () => <LinkedShowSimplePanel
          key="linkedShows"
          linkedShows={props.linkedShows}
          linkShowToTravel={props.linkShowToTravel}
        />
      }
    ]}
  />
}
